import { LoadingLayout } from 'components';
import { useScrollToTop } from 'hooks/useScrollToTop';
import { ErrorFallback } from 'modules/App/ErrorFallback';
import { LegalClientAddFirstHeadDialogFeature } from 'modules/client/legalClientAddFirstHead';

import { useLegalClientLegalHead } from '../hooks';
import { LegalClientLegalHeadView } from '../views/LegalClientLegalHeadView';

export const LegalClientLegalHeadContainer = () => {
  const {
    loading,
    legalClientLegalHead,
    legalClient,
    countries,
    countriesLoading,
    error,
    initialValues,
    submitLoading,
    breadcrumbsTitles,
    deleteLoading,
    archiveLoading,
    dearchiveLoading,
    dialogAddFirstHeadDialogProps,
    onDeleteFirstHead,
    lockClientIfPossible,
    unlockClient,
    onSubmit,
    onShowVersionHistory,
    refetchLegalClientLegalHead,
    onDelete,
    onArchive,
    onDearchive,
    onArchiveFirstHead,
    onDearchiveFirstHead,
    onClickAddFirstHead,
    onClickFirstHead,
  } = useLegalClientLegalHead();

  const onSuccessAddFirstHead = () => {
    dialogAddFirstHeadDialogProps.onClose();
    refetchLegalClientLegalHead();
  };

  useScrollToTop([]);

  if (error || (!legalClientLegalHead && !loading)) {
    return <ErrorFallback />;
  }

  if (loading || !legalClientLegalHead) {
    return <LoadingLayout />;
  }

  return (
    <>
      <LegalClientLegalHeadView
        archiveLoading={archiveLoading}
        bodies={legalClient?.bodies ?? []}
        breadcrumbsTitles={breadcrumbsTitles}
        countries={countries}
        countriesLoading={countriesLoading}
        dearchiveLoading={dearchiveLoading}
        deleteLoading={deleteLoading}
        firstHeads={legalClientLegalHead.firstHeads ?? []}
        initialValues={initialValues}
        lockClientIfPossible={lockClientIfPossible}
        submitLoading={submitLoading}
        unlockClient={unlockClient}
        onArchive={onArchive}
        onArchiveFirstHead={onArchiveFirstHead}
        onClickAddFirstHead={onClickAddFirstHead}
        onClickFirstHead={onClickFirstHead}
        onDearchive={onDearchive}
        onDearchiveFirstHead={onDearchiveFirstHead}
        onDelete={onDelete}
        onDeleteFirstHead={onDeleteFirstHead}
        onShowVersionHistory={onShowVersionHistory}
        onSubmit={onSubmit}
      />
      <LegalClientAddFirstHeadDialogFeature
        legalClientLegalHead={legalClientLegalHead}
        onSuccess={onSuccessAddFirstHead}
        {...dialogAddFirstHeadDialogProps}
      />
    </>
  );
};
